// @flow @jsx h

import { PolopolyPicture } from '@nrk/dh-feature-components'
import { h } from 'preact'
import style from './index.css'

type Text = {
  type: 'text',
  value: string
}

type Props = {
  value: {
    horizontalId: string,
    src: string,
    alt: string,
    caption?: Text[],
    credit: string
  },
  mediaBaseUrl: string
}

function FigureCaption (props: Props) {
  const { caption, credit } = props.value

  if (!caption && !credit) {
    return null
  }

  return (
    <figcaption>
      {caption &&
        caption.map(item => {
          switch (item.type) {
            case 'text':
              return <p dangerouslySetInnerHTML={{ __html: item.value }} />
          }
        })}
      {credit && <div className={style.figure__credit}>{credit}</div>}
    </figcaption>
  )
}

function Figure (props: Props) {
  const { alt, horizontalId } = props.value
  return (
    <figure className={style.figure}>
      <PolopolyPicture
        horizontal={{ id: horizontalId, quality: 'best' }}
        alt={alt}
      />
      <FigureCaption {...props} />
    </figure>
  )
}

export default Figure



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Figure/index.js